export default "__VITE_ASSET__dC2dVHUF__"